import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { flowRight as compose } from 'lodash';
import { injectIntl } from 'react-intl';

import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import CustomPagination from '../../CustomPagination';
import AdminRolesModal from '../AdminRolesModal';
import CommonTable from '../../CommonTable/CommonTable';
import TableAction from '../../CommonTable/TableAction';
import Loader from '../../Loader/Loader';

import { openAdminRolesModal } from '../../../actions/siteadmin/modalActions';
import { deleteAdminRole } from '../../../actions/siteadmin/AdminRoles/manageAdminRoles';
import adminRolesQuery from './adminRolesQuery.graphql';
import debounce from '../../../helpers/debounce';

import { withQuery } from '../../../hoc/withGraphql';

import cs from '../../../components/commonStyle.css';
import s from './AdminRolesManagement.css';
import messages from '../../../locale/jsonMessages';

class AdminRolesManagement extends React.Component {

  static propTypes = {
    adminRoles: PropTypes.array,
    title: PropTypes.string.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      searchList: '',
      typing: false,
      typingTimeout: 0
    }
    this.setStateVariable = this.setStateVariable.bind(this);

  }

  setStateVariable(variables) {
    this.setState(variables);
  };

  paginationData = (currentPage) => {
    const { adminRoles: { refetch } } = this.props;
    let variables = { currentPage };
    this.setStateVariable(variables);
    refetch(variables);
  };

  handleDelete = async (id) => {
    const { adminRoles: { refetch, getAllAdminRoles } } = this.props;
    const { currentPage } = this.state
    const { deleteAdminRole } = this.props;
    let variables = { currentPage: currentPage > 1 && getAllAdminRoles?.results?.length == 1 ? currentPage - 1 : currentPage };
    const response = await deleteAdminRole(id);
    if (response?.status == 200) {
      await this.setStateVariable(variables);
      await refetch(variables);
    }
  };

  handleKeywordSearch = debounce((value) => { // Keyword search
    const { adminRoles: { refetch }, setStateVariable } = this.props;
    let variables = {
      currentPage: 1,
      searchList: value
    };
    this.setStateVariable(variables);
    refetch(variables);
  }, 300)


  handleModalopen = (value) => {
    const { openAdminRolesModal } = this.props;
    if (value) openAdminRolesModal('edit', value)
    else openAdminRolesModal('add')
  }

  thead = () => {
    const { formatMessage } = this.props.intl;
    return [
      { data: formatMessage(messages.idLabel) },
      { data: formatMessage(messages.name) },
      { data: formatMessage(messages.descriptionAdminLabel) }
    ]
  };


  tbody = (props) => {
    const { adminRoles: { getAllAdminRoles } } = props;
    return getAllAdminRoles?.results?.map((value, key) => {
      return {
        id: key,
        data: [
          { data: value.id },
          {
            data: <div className={cx(cs.displayFlex, cs.alignCenter, cs.spaceBetween)}>
              {value?.name}
              <TableAction
                onClickDelete={() => this.handleDelete(value.id)}
                showDelete={true}
                showEdit={true}
                editAction={() => this.handleModalopen(value)}
              /> </div>
          },
          { data: value.description },
        ]
      }
    })
  }

  render() {
    const { adminRoles: { loading, getAllAdminRoles } } = this.props;
    const { currentPage } = this.state;
    const { formatMessage } = this.props.intl;

    if (loading) {
      return <Loader type={"text"} />
    }

    return (
      <div >
        <AdminRolesModal paginationData={this.paginationData} />
        <CommonTable
          thead={this.thead}
          tbody={() => this.tbody(this.props)}
          title={formatMessage(messages.manageAdminRoles)}
          isLink
          addAction={this.handleModalopen}
          redirectionLabel={formatMessage(messages.addNewLabel)}
          isSearch
          onSearch={(e) => this.handleKeywordSearch(e?.target?.value)}
        />
        {
          !loading && getAllAdminRoles?.count > 0
          && <div>
            <CustomPagination
              total={getAllAdminRoles.count}
              currentPage={currentPage}
              defaultCurrent={1}
              defaultPageSize={10}
              change={this.paginationData}
              paginationLabel={formatMessage(messages.roles)}
            />
          </div>
        }
      </div>
    );
  }

}

const mapState = (state) => ({});

const mapDispatch = {
  openAdminRolesModal,
  deleteAdminRole
};

export default compose(
  injectIntl,
  withStyles(cs, s),
  connect(mapState, mapDispatch),
  withQuery(adminRolesQuery, {
    name: 'adminRoles',
    options: (props) => ({
      variables: {
        searchList: props.searchList,
        currentPage: props.currentPage,
      },
      fetchPolicy: 'network-only',
      ssr: false
    })
  }),
)(AdminRolesManagement);